// extracted by mini-css-extract-plugin
module.exports = {"link":"UserProfileGeneralInfo_link__1pPO7"};